import React from 'react'
import useTranslation from '../../../modules/i18n/useTranslation'

const PromoBadge: React.FC = () => {
  const { isLocaleKO } = useTranslation()
  return (
    <div className="ml-8 inline-block rounded-md bg-red-50  px-8 text-[14px] font-medium leading-[20px] text-red-500">
      Promo
    </div>
  )
}

export default PromoBadge
